import { WysiwygComponent } from './wysiwyg/wysiwyg.component';

export const Components = [
	WysiwygComponent,
];
